import { useContent } from '@/hooks/useContent';

export default function AboutHero() {
  const { t } = useContent('about');
  const { t: imgT } = useContent('images');

  return (
    <section className="relative w-full h-[340px] md:h-[420px] flex items-center justify-center overflow-hidden pt-12 md:pt-16">
      <div className="absolute inset-0">
        <img
          alt="FMO LLC Insulation Services professional team"
          className="w-full h-full object-cover object-center"
          src={imgT('about_hero')}
        />
        <div className="absolute inset-0 bg-black/70"></div>
      </div>
      <div className="relative z-10 flex items-center justify-center">
        <div className="bg-black/70 border-2 border-primary-500 rounded-xl px-14 py-6 md:px-20 md:py-7">
          <h1 className="text-3xl md:text-4xl font-extrabold text-white uppercase tracking-[0.2em] text-center">{t('about_hero_title')}</h1>
        </div>
      </div>
    </section>
  );
}